import { Route } from "react-router-dom";
import DashboardProfile from "src/views/authenticated/profile/ProfileView";
import DashboardBillingUpcomingView from "src/views/authenticated/profile/billing/BillingUpcomingView";
import DashboardBillingView from "src/views/authenticated/profile/billing/BillingView";
import DashboardChangeMandateView from "src/views/authenticated/profile/billing/ChangeMandateView";
import DashboardChangePlanView from "src/views/authenticated/profile/billing/ChangePlanView";
import DashboardPausePlanView from "src/views/authenticated/profile/billing/PausePlanView";
import DashboardResumePlanView from "src/views/authenticated/profile/billing/ResumePlanView";
import DashboardCompaniesView from "src/views/authenticated/profile/companies/CompaniesView";
import DashboardCompanyView from "src/views/authenticated/profile/company-view/CompanyView";
import UsersView from "src/views/authenticated/profile/users/UsersView";
import DashboardViewProfileView from "src/views/authenticated/view-profile/ViewProfileView";
import ProtectedRoute from "src/routes/middlewares/ProtectedRoute";
import TeamFormModal from "src/views/authenticated/profile/teams/TeamFormModal";
import EditUserModal from "src/views/authenticated/profile/users/EditUserModal";
import InviteUserModal from "src/views/authenticated/profile/users/InviteUserModal";
import TeamsView from "src/views/authenticated/profile/teams/TeamsView";

const ProfileRoutes = [
	<Route
		element={
			<ProtectedRoute>
				<DashboardViewProfileView />
			</ProtectedRoute>
		}
		path="/view-profile/:id"
		key="/view-profile/:id"
	/>,
	<Route
		element={
			<ProtectedRoute>
				<DashboardProfile />
			</ProtectedRoute>
		}
		path="/profile/show"
		key="/profile/show"
	/>,
	<Route
		element={
			<ProtectedRoute type="company">
				<DashboardCompanyView />
			</ProtectedRoute>
		}
		path="/profile/company"
		key="/profile/company"
	/>,
	<Route
		element={
			<ProtectedRoute type="company">
				<DashboardCompaniesView />
			</ProtectedRoute>
		}
		path="/profile/companies"
		key="/profile/companies"
	/>,
	<Route
		element={
			<ProtectedRoute type="company">
				<UsersView />
			</ProtectedRoute>
		}
		path="/profile/users"
		key="/profile/users"
	/>,
	<Route
		element={
			<ProtectedRoute type="company">
				<TeamsView />
			</ProtectedRoute>
		}
		path="/profile/teams"
		key="/profile/teams"
	/>,
	<Route
		element={
			<ProtectedRoute type="company">
				<DashboardBillingView />
			</ProtectedRoute>
		}
		path="/profile/billing"
		key="/profile/billing"
	/>,
	<Route
		element={
			<ProtectedRoute type="company">
				<DashboardChangePlanView />
			</ProtectedRoute>
		}
		path="/profile/billing/change"
		key="/profile/billing/change"
	/>,
	<Route
		element={
			<ProtectedRoute type="company">
				<DashboardChangeMandateView />
			</ProtectedRoute>
		}
		path="/profile/billing/change/mandate"
		key="/profile/billing/change/mandate"
	/>,
	<Route
		element={
			<ProtectedRoute type="company">
				<DashboardPausePlanView />
			</ProtectedRoute>
		}
		path="/profile/billing/change/pause"
		key="/profile/billing/change/pause"
	/>,
	<Route
		element={
			<ProtectedRoute type="company">
				<DashboardResumePlanView />
			</ProtectedRoute>
		}
		path="/profile/billing/change/resume"
		key="/profile/billing/change/resume"
	/>,
	<Route
		element={
			<ProtectedRoute type="company">
				<DashboardBillingUpcomingView />
			</ProtectedRoute>
		}
		path="/profile/billing/upcoming"
		key="/profile/billing/upcoming"
	/>,
];

export const ProfileModalRoutes = [
	<Route
		element={
			<ProtectedRoute
				variant="modal"
				modal={{
					backUrl: "/profile/teams",
					expanded: false,
					size: "default",
				}}
				type="company"
			>
				<TeamFormModal />
			</ProtectedRoute>
		}
		path="/profile/teams/create"
		key="/profile/teams/create"
	/>,
	<Route
		element={
			<ProtectedRoute
				variant="modal"
				modal={{
					backUrl: "/profile/teams",
					expanded: false,
					size: "default",
				}}
				type="company"
			>
				<TeamFormModal />
			</ProtectedRoute>
		}
		path="/profile/teams/:id/edit"
		key="/profile/teams/:id/edit"
	/>,
	<Route
		element={
			<ProtectedRoute
				variant="modal"
				modal={{
					backUrl: "/profile/users",
					expanded: false,
					size: "default",
				}}
				type="company"
			>
				<EditUserModal />
			</ProtectedRoute>
		}
		path="/profile/users/:id/edit"
		key="/profile/users/:id/edit"
	/>,
	<Route
		element={
			<ProtectedRoute
				variant="modal"
				modal={{
					backUrl: "/profile/users",
					expanded: false,
					size: "default",
				}}
				type="company"
			>
				<InviteUserModal />
			</ProtectedRoute>
		}
		path="/profile/users/invite"
		key="/profile/users/invite"
	/>,
];

export default ProfileRoutes;
